import { render, staticRenderFns } from "./SupplierGroupListView.vue?vue&type=template&id=2fc48379"
import script from "./SupplierGroupListView.vue?vue&type=script&lang=js"
export * from "./SupplierGroupListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports